<template>
  <div
    @click="() => $router.push(path)"
    class="back-button-container d-flex align-center ga-2"
  >
    <v-chip rounded="circle" color="#BD9478">
      <v-icon size="16px" :icon="'mdi-arrow-right'"></v-icon>
    </v-chip>
    <span class="back-label">{{ $t("SingelDoc.backButton") }}</span>
  </div>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
.back-button-container {
  cursor: pointer;
  .v-chip.v-chip--size-default {
    padding: 0 6px !important;
    height: 28px;
  }
}

.back-button-container {
  .back-label {
    font-size: $mediumTextSize;
    font-weight: 400;
    color: $primaryColor;
  }
}
</style>
